import React, {useState, useEffect} from "react";
import {useObserver} from "mobx-react-lite";
import {useStore} from "../../../hooks/useStore";
import {useFetch} from "../../../hooks/useFetch";
import {useTranslation} from "react-i18next";

import "antd/dist/antd.css";
import {cities} from "../../../constants/constants";
import PolyMap from "../Polygons/PolyMap";

import {Col, Row} from "antd";
import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {FilterRow, SelectField, MapContainer} from "./regionStyles";
import {CityFilter, CompanyFilter} from "../../_defaultComponents/FilterComponents";

export const Region = () => {
    const stores = useStore();
    const {t} = useTranslation(["region"]);
    const [center, setCenter] = useState({lat: 41.11, lng: 29.11});
    const [selectedCity, setSelectedCity] = useState("istanbul");
    const [showInfo, setShowInfo] = useState(-1);
    const [zones, setZones] = useState([]);
    const [companyFilter, setCompanyFilter] = useState("");
    const [regionGroupName, setRegionGroupName] = useState("");
    const [companyId, setCompanyId] = useState("");
    const [regionId, setRegionId] = useState("");

    const [loading, data, setData, setLoading] = useFetch({
        fetchFn: stores.regionStore.getRegionList.bind(null, {
            city: selectedCity
        }),
        dependencies: [selectedCity, showInfo === undefined]
    });

    const [regionGroupsLoading, regionGroups, setRegionGroups, setRegionGroupsLoading] = useFetch({
        fetchFn: stores.regionStore.getRegionGroups.bind(null),
        initialCall: true
    });

    const [
        regionGroupsByCompanyLoading,
        regionGroupsByCompany,
        setRegionGroupsByCompany,
        setRegionGroupsByCompanyLoading
    ] = useFetch({
        fetchFn: stores.regionStore.getRegionGroups.bind(null, {
            companyId: companyFilter,
            city: selectedCity
        }),
        dependencies: [companyFilter, selectedCity, showInfo === undefined],
        initialCall: false,
        condition: companyFilter !== ""
    });

    useEffect(() => {
        let zonesArray = [];
        data.map((item, index) =>
            item.polygon.coordinates.map(polygon => {
                const zoneData = [];
                polygon.map(eachof => {
                    zoneData.push({lat: parseFloat(eachof[1]), lng: parseFloat(eachof[0])});
                });
                zonesArray.push({
                    id: item._id,
                    zoneData: zoneData,
                    name: item.name,
                    center: item.center,
                    group: item?.group || null
                });
            })
        );

        setZones(zonesArray);
    }, [data]);

    const showInfoWindow = index => {
        setShowInfo(index);
    };

    return useObserver(() => (
        <div data-testid="regionScreens">
            <FilterRow gutter={[20, 20]}>
                <Col xs={20} sm={16} md={12} lg={8} xl={4}>
                    <CityFilter
                        value={selectedCity}
                        onChange={(value, option) => {
                            setSelectedCity(value);
                            setCenter(option["data-center"]);
                        }}
                    />
                </Col>
                <Col xs={20} sm={16} md={12} lg={8} xl={5} span={5}>
                    <h5>Seçenek</h5>
                    <SelectField
                        showSearch
                        value={companyFilter}
                        data-testid="city"
                        onChange={value => setCompanyFilter(value)}
                    >
                        <SelectField.Option data-testid="city_option" key={"Üst Grup"} value="">
                            Üst Grup
                        </SelectField.Option>
                        <SelectField.Option
                            data-testid="city_option"
                            key={"Bölge Grubu"}
                            value="pool"
                        >
                            Bölge Grubu
                        </SelectField.Option>
                    </SelectField>
                </Col>
            </FilterRow>
            <Row type="flex" justify="center">
                <Col md={24} sm={12}>
                    <MapContainer>
                        <PolyMap
                            center={center}
                            showInfo={showInfo}
                            showInfoWindow={showInfoWindow}
                            zones={zones}
                            regionGroups={regionGroups}
                            regionGroupsByCompany={regionGroupsByCompany}
                            companyFilter={companyFilter}
                        />
                    </MapContainer>
                </Col>
            </Row>
        </div>
    ));
};
